import Link from '../../../../../assets/link.svg';
import { useState } from 'react';
import LinkInputForm from './LinkInputForm';
import { Box, IconButton } from '@coolblue-development/freddy';

const LinkButton = (): JSX.Element => {
  const [toggle, setToggle] = useState(false);

  const onClick: React.MouseEventHandler<HTMLButtonElement> = () => {
    setToggle(!toggle);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <IconButton
        onClick={onClick}
        size="small"
        sx={{
          width: 'auto',
          height: 'auto',
          padding: '8px',
          ':hover': { background: '#F3F3F3' },
          background: toggle ? '#F3F3F3' : 'transparent'
        }}
        variant="transparent"
      >
        <Link />
      </IconButton>
      {toggle && <LinkInputForm />}
    </Box>
  );
};

export default LinkButton;
